'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Var-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024 from "./com.raquo.airstream.core.-Observer$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dStrict$002dSignal from "./com.raquo.airstream.state.-Lazy-Strict-Signal.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dVar$0024$0024anon$00241 from "./com.raquo.airstream.state.-Var$$anon$1.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
function $f_Lcom_raquo_airstream_state_Var__$init$__V($thiz) {
  $thiz.Bg($j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024.$m_Lcom_raquo_airstream_core_Observer$().UL(new $j_com$002eraquo$002eairstream$002estate$002e$002dVar$0024$0024anon$00241.$c_Lcom_raquo_airstream_state_Var$$anon$1($thiz), ($j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024.$m_Lcom_raquo_airstream_core_Observer$(), true)));
}
export { $f_Lcom_raquo_airstream_state_Var__$init$__V as $f_Lcom_raquo_airstream_state_Var__$init$__V };
function $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var($thiz, in$1, out) {
  return new $c_Lcom_raquo_airstream_state_LazyDerivedVar($thiz, new $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dStrict$002dSignal.$c_Lcom_raquo_airstream_state_LazyStrictSignal($thiz.a4(), in$1, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T($thiz))), ".zoomLazy.signal"), out, ".zoomLazy");
}
export { $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var as $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var };
function $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz, value) {
  var tryValue = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(value);
  $thiz.uI().fY(tryValue);
}
export { $f_Lcom_raquo_airstream_state_Var__set__O__V as $f_Lcom_raquo_airstream_state_Var__set__O__V };
function $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz, mod) {
  new $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    matchResult12: {
      var x36 = $thiz.a4().b3();
      if ((x36 instanceof $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success)) {
        var currentValue = x36.e5;
        try {
          var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(mod.j(currentValue));
        } catch (e) {
          var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
          matchResult1: {
            var $x_1;
            var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
            if ((!x2.k())) {
              var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
              break matchResult1;
            }
            throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
          }
        }
        $thiz.rl($x_1, trx);
        break matchResult12;
      }
      if ((x36 instanceof $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure)) {
        var err = x36.h8;
        $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to update a failed Var. Consider Var#tryUpdate instead.", new $j_java$002elang$002e$002dObject.$c_s_Some(err)));
        break matchResult12;
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x36);
    }
  })));
}
export { $f_Lcom_raquo_airstream_state_Var__update__F1__V as $f_Lcom_raquo_airstream_state_Var__update__F1__V };
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyDerivedVar(parent, signal, zoomOut, displayNameSuffix) {
  this.F2 = null;
  this.yO = null;
  this.v4 = null;
  this.yN = null;
  this.F3 = null;
  this.F1 = null;
  this.v4 = parent;
  this.yN = signal;
  this.F3 = zoomOut;
  this.F1 = displayNameSuffix;
  this.F2 = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
}
export { $c_Lcom_raquo_airstream_state_LazyDerivedVar as $c_Lcom_raquo_airstream_state_LazyDerivedVar };
$p = $c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_LazyDerivedVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyDerivedVar() {
}
export { $h_Lcom_raquo_airstream_state_LazyDerivedVar as $h_Lcom_raquo_airstream_state_LazyDerivedVar };
$h_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = $p;
$p.dP = (function() {
  return this.F2;
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.uI = (function() {
  return this.yO;
});
$p.Bg = (function(x$0) {
  this.yO = x$0;
});
$p.lh = (function() {
  return this.yO;
});
$p.a4 = (function() {
  return this.yN;
});
$p.rl = (function(value, transaction) {
  var x1 = this.v4.a4().b3();
  if ((x1 instanceof $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success)) {
    var parentValue = x1.e5;
    var nextValue = value.ra(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => this.F3.bB(parentValue, _$1))));
    this.v4.rl(nextValue, transaction);
    return (void 0);
  }
  if ((x1 instanceof $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure)) {
    var err = x1.h8;
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to zoom out of lazy derived var when the parent var is failed.", new $j_java$002elang$002e$002dObject.$c_s_Some(err)));
    return (void 0);
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x1);
});
$p.dd = (function() {
  return (("" + $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this.v4)) + this.F1);
});
$p.dS = (function() {
  return this.yN;
});
var $d_Lcom_raquo_airstream_state_LazyDerivedVar = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_LazyDerivedVar, "com.raquo.airstream.state.LazyDerivedVar", ({
  hh: 1,
  a1: 1,
  au: 1,
  aP: 1,
  M: 1,
  c4: 1
}));
export { $d_Lcom_raquo_airstream_state_LazyDerivedVar as $d_Lcom_raquo_airstream_state_LazyDerivedVar };
